import { useState } from "react";
import { createContainer } from "unstated-next";

/**
 * Shared state container for password reset components.
 */
function useResetState() {
  const [isWaitingForEmail, setIsWaitingForEmail] = useState(false);
  const [isWaitingForLink, setIsWaitingForLink] = useState(false);

  return {
    isWaitingForEmail,
    setIsWaitingForEmail,

    isWaitingForLink,
    setIsWaitingForLink,
  };
}

export const ResetState = createContainer(useResetState);
